module.exports = __webpack_public_path__ + "assets/img/lastz0.310e4773.png";